import firebase from 'firebase/compat/app'
import 'firebase/compat/firestore'
import dayjs from 'dayjs'
const db = firebase.firestore()

const state = {
  activities: [],
  allActivities: []
}

const actions = {
  GET_ALL_ACTIVITIES ({ commit, rootState }) {
    const user = rootState.auth && rootState.auth.user
    if (!user || !user.isAdmin) {
      return Promise.reject(new Error('Permission denied: admin only'))
    }
    let resolved = false
    return new Promise((resolve, reject) => {
      let ref = db.collectionGroup('activities')
        .orderBy('createdAt', 'desc')
        .limit(100)

      let unsub = ref.onSnapshot(snapshot => {
        let activities = []
        snapshot.forEach(doc => {
          const data = doc.data()
          const applicantId = doc.ref.parent.parent ? doc.ref.parent.parent.id : null
          activities.push({ id: doc.id, applicantId, ...data })
        })
        commit('SET_ALL_ACTIVITIES', activities)
        if (!resolved) {
          resolved = true
          resolve(unsub)
        }
      }, error => {
        console.error('GET_ALL_ACTIVITIES error:', error)
        if (!resolved) {
          resolved = true
          reject(error)
        }
      })
    })
  },

  GET_ACTIVITIES ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      let ref = db.collection('applicants')
        .doc(payload.applicantId)
        .collection('activities')
        .orderBy('createdAt', 'desc')
        .limit(50)

      let unsub = ref.onSnapshot(snapshot => {
        let activities = []
        snapshot.forEach(doc => {
          activities.push({ id: doc.id, ...doc.data() })
        })
        commit('SET_ACTIVITIES', activities)
      }, error => {
        reject(error)
      })
      resolve(unsub)
    })
  },

  DELETE_ACTIVITY ({ commit }, { applicantId, activityId }) {
    return db.collection('applicants')
      .doc(applicantId)
      .collection('activities')
      .doc(activityId)
      .delete()
  },

  CREATE_ACTIVITY ({ commit, rootState }, payload) {
    const authUser = rootState.auth && rootState.auth.user
    const userName = payload.user ||
      (authUser && (authUser.firstName || authUser.username || authUser.name)) ||
      'System'

    const data = {
      type: payload.type,
      message: payload.message,
      details: payload.details || null,
      user: userName,
      createdAt: dayjs().format()
    }

    if (payload.changes && payload.changes.length) {
      data.changes = payload.changes
    }

    return db.collection('applicants')
      .doc(payload.applicantId)
      .collection('activities')
      .add(data)
  }
}

const getters = {}

const mutations = {
  SET_ACTIVITIES (state, payload) {
    state.activities = payload
  },
  SET_ALL_ACTIVITIES (state, payload) {
    state.allActivities = payload
  },
  CLEAR_ACTIVITIES (state) {
    state.activities = []
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
